import { useState } from 'react';

export type ExpandingAllInTableType = {
  isAllExpanded: () => boolean,
  toggleAllExpanded: () => void,
  expandedRowKeys: Array<string | number>,
  onExpand: (expanded: boolean, record: any) => void,
  rowKey: string,
};

export const useExpandingAllInTable = (
  keys: Array<string | number>,
  keyName: string,
  defaultExpanded: boolean,
) => {
  const [expandedKeys, setExpandedKeys] = useState(defaultExpanded ? keys : []);
  const isAllExpanded = () => (
    expandedKeys.length
    && expandedKeys.length
    && expandedKeys.length === keys.length
  ) || false;

  const toggleRowExpanded = (expanded, record) => {
    if (expanded) {
      setExpandedKeys(expandedKeys.concat([record[keyName]]));
    } else {
      setExpandedKeys(expandedKeys.filter(item => item !== record[keyName]));
    }
  };

  const toggleAllExpanded = () => {
    if (isAllExpanded()) {
      setExpandedKeys([]);
    } else {
      setExpandedKeys(keys);
    }
  };

  return {
    isAllExpanded,
    toggleAllExpanded,
    expandedRowKeys: expandedKeys,
    onExpand: toggleRowExpanded,
    rowKey: keyName,
  };
};
